import { render, staticRenderFns } from "./agreement4.vue?vue&type=template&id=d645b2aa&scoped=true"
var script = {}
import style0 from "./agreement4.vue?vue&type=style&index=0&id=d645b2aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d645b2aa",
  null
  
)

export default component.exports